/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Assets
 */
export interface Assets {
}

/**
 * Check if a given object implements the Assets interface.
 */
export function instanceOfAssets(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AssetsFromJSON(json: any): Assets {
    return AssetsFromJSONTyped(json, false);
}

export function AssetsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Assets {
    return json;
}

export function AssetsToJSON(value?: Assets | null): any {
    return value;
}

